import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import {
  EXPANDED_DESKTOP_NAVBAR_WIDTH,
  EXPANDED_TABLET_NAVBAR_WIDTH,
} from 'pages/PlaygroundV2Page/helpers';
import { MAIN_BOX_SHADOW } from 'utils/theme';
import UserAvatar from '../components/UserAvatarWithMenu';
import NavbarLogo from '../NavBar/components/NavbarLogo';
import NavbarToggler from '../NavBar/components/NavbarToggler';
import ActionButtons from './components/ActionButtons';
import MenuFooter from './components/MenuFooter';
import SmallScreenNavHeader from './components/SmallScreenNavHeader';

const SMALL_SCREEN_NAVBAR_BOX_SHADOW = '0px 4px 6px rgba(0, 0, 0, 0.1)';

const ExpandedNavbar = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('desktop'));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('tablet'));

  return (
    <Box
      bgcolor="white"
      display="flex"
      alignItems="center"
      boxShadow={isSmallScreen ? SMALL_SCREEN_NAVBAR_BOX_SHADOW : MAIN_BOX_SHADOW}
      zIndex={1000}
      sx={{
        flexDirection: 'column',
        width: isMobileScreen
          ? '100%'
          : `${isSmallScreen ? EXPANDED_TABLET_NAVBAR_WIDTH : EXPANDED_DESKTOP_NAVBAR_WIDTH}px`,
        height: '100vh',
        borderRadius: 0,
        padding: 0,
        margin: 0,
        position: 'fixed',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        right: isSmallScreen ? 0 : 'auto',
        left: isSmallScreen ? 'auto' : 0,
      }}
    >
      {/* navbar header */}
      {isSmallScreen ? <SmallScreenNavHeader /> : <NavbarLogo />}

      {/* navbar body */}
      {!isSmallScreen && <UserAvatar />}
      {isMobileScreen && (
        <Box p={2} mt="86px" width="100%">
          <Typography
            fontSize="40px"
            fontWeight="300"
            sx={{
              fontFamily: 'ABCArizonaSerif',
              margin: '16px',
              width: '295px',
            }}
            lineHeight="52px"
          >
            Power your content with credible sources
          </Typography>
        </Box>
      )}
      <ActionButtons />
      {/* navbar footer */}
      {!isSmallScreen && <NavbarToggler />}
      <MenuFooter isMobileScreen={isMobileScreen} />
    </Box>
  );
};

export default ExpandedNavbar;
